/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Badge_LeftInputs */

const en_us2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const pt_br2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E`)
};

const es_419_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I`)
};

const pt_pt2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E`)
};

const fr_fr2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

const de_de2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const it_it2_workout_logging_badge_left = /** @type {(inputs: Workout_Logging_Badge_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

/**
* | output |
* | --- |
* | "L" |
*
* @param {Workout_Logging_Badge_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_badge_left = /** @type {((inputs?: Workout_Logging_Badge_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Badge_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_badge_left(inputs)
	if (locale === "es-419") return es_419_workout_logging_badge_left(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_badge_left(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_badge_left(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_badge_left(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_badge_left(inputs)
	return en_us2_workout_logging_badge_left(inputs)
});
export { workout_logging_badge_left as "workout-logging.badge_left" }